import { CheckmarkIcon, CloseIcon } from "@theprelude/ds";

export function ScheduleStatus({ status }: { status: boolean | undefined }) {
  if (status === undefined) {
    return (
      <div className="w-max border border-stroke-line px-1 py-0.5 text-secondary-foreground">
        Deleted
      </div>
    );
  }

  if (status) {
    return (
      <div className="flex flex-row items-center gap-1 whitespace-nowrap text-status-green">
        <CheckmarkIcon />
        Yes
      </div>
    );
  }

  return (
    <div className="flex flex-row items-center gap-1 whitespace-nowrap text-status-red">
      <CloseIcon />
      No
    </div>
  );
}
